const permitRequestsReducer = (previousState = 0, { type, payload }) => {
    if (type === 'UPDATE_PERMIT_REQUESTS_COUNT') {
        return payload.permitRequestsCount;
    }
    return previousState;
}
export default permitRequestsReducer;